/**
 * 手机号校验和格式化工具
 * 规则：
 * - 有 + 号且不是 +81：原样存储（只去空格横线）
 * - 有 + 号且是 +81：去掉 +81 和前导0，剩余需 9~10 位，拼接 +81
 * - 无 + 号，以 0 开头：视为日本本地号码，去掉前导0，需 9~10 位，拼接 +81
 * - 无 + 号，不以 0 开头：视为日本号码（已无前导0），需 9~10 位，拼接 +81
 */
var PhoneUtils = {
  /**
   * 校验手机号格式
   * @param {string} phone 用户输入的手机号
   * @returns {boolean} 是否合法
   */
  validate: function(phone) {
    if (!phone) return false;
    // 去掉空格和横线
    var cleaned = phone.replace(/[\s\-]/g, '');

    if (cleaned.startsWith('+')) {
      var digits = cleaned.substring(1);
      if (!/^\d+$/.test(digits)) return false;

      if (digits.startsWith('81')) {
        // +81 开头：去掉81和前导0，检查剩余是否为9~10位
        var local = digits.substring(2);
        if (local.startsWith('0')) {
          local = local.substring(1);
        }
        return local.length >= 9 && local.length <= 10;
      } else {
        // 非 +81：E.164 总长度 10~15 位即可
        return digits.length >= 10 && digits.length <= 15;
      }
    } else {
      // 无 + 号：视为日本本地号码
      if (!/^\d+$/.test(cleaned)) return false;
      var local = cleaned;
      if (local.startsWith('0')) {
        local = local.substring(1);
      }
      return local.length >= 9 && local.length <= 10;
    }
  },

  /**
   * 格式化为 E.164 格式
   * @param {string} phone 用户输入的手机号
   * @returns {string} E.164格式手机号
   */
  formatE164: function(phone) {
    if (!phone) return '';
    // 去掉空格和横线
    var cleaned = phone.replace(/[\s\-]/g, '');

    if (cleaned.startsWith('+')) {
      var digits = cleaned.substring(1);

      if (digits.startsWith('81')) {
        // +81 开头：去掉81和前导0，截取最后有效位数，拼接 +81
        var local = digits.substring(2);
        if (local.startsWith('0')) {
          local = local.substring(1);
        }
        return '+81' + local;
      } else {
        // 非 +81：原样返回（只清理了空格横线）
        return '+' + digits;
      }
    } else {
      // 无 + 号：视为日本本地号码，去掉前导0，拼接 +81
      var local = cleaned;
      if (local.startsWith('0')) {
        local = local.substring(1);
      }
      return '+81' + local;
    }
  }
};
